// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"b157bebf","765":"b5928d18","787":"351c4612"}[chunkId] + ".chunk.js";
};